var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex flex-wrap mt-1 w-full overflow-hidden" },
    [
      _c(
        "div",
        { staticClass: "w-12/12 column px-gap carousel--product" },
        [
          _vm.modules?.media
            ? _c(
                "Swiper",
                {
                  ref: "productSwiper",
                  staticClass: "w-full swiper__slide",
                  attrs: { options: _vm.productSwiperOptions },
                },
                _vm._l(_vm.modules?.media, function (slide, index) {
                  return _c(
                    "SwiperSlide",
                    {
                      key: index,
                      staticClass: "flex justify-center items-center",
                    },
                    [
                      slide?.sys?.contentType?.sys?.id === "image"
                        ? _c("PictureWrapper", {
                            attrs: {
                              image: slide.fields,
                              "data-not-lazy": "",
                              stuff: "",
                            },
                          })
                        : slide?.sys?.contentType?.sys?.id === "video"
                        ? _c("img", {
                            attrs: {
                              src: `https://img.youtube.com/vi/${slide.fields.id}/hqdefault.jpg`,
                              "data-not-lazy": "",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.modules.media
            ? _c(
                "div",
                { staticClass: "swiper__dots mt-2 flex justify-center" },
                _vm._l(_vm.modules?.media, function (slide, index) {
                  return _c("ProductCarouselDot", {
                    key: index,
                    staticClass: "swiper__dot border-1 cursor-pointer mr-1",
                    attrs: {
                      slide: slide,
                      index: index,
                      active: _vm.active,
                      last:
                        _vm.modules && _vm.modules.media
                          ? _vm.modules.media.length
                          : 0,
                    },
                    on: {
                      clicked: function ($event) {
                        return _vm.goToSlide(index)
                      },
                    },
                  })
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }